import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../IconButton/IconButton';
import { LanguageSelector } from '../LanguageSelector/LanguageSelector';
import { NotificationsList } from '../NotificationsList/NotificationsList';
import { ProfileCircle } from '../ProfileCircle/ProfileCircle';
import { NotificationButtonToggle } from './TopbarToggles';
import styles from './Topbar.module.scss';

/** Mostra le azioni della topbar per lingua, abbonamento, notifiche e profilo. */
const TopbarActions = ({
  isLoggedIn,
  isMobile,
  isDesktopViewport,
  isNative,
  isGamingEnabled,
  subscription,
  userDataFmt,
  notificationBadge,
  cleanNotifications,
  showLoginButtonIfNeeded,
  showSubscribeButtonIfNeeded,
  onLogin,
}: any) => {
  const { t } = useTranslation();
  const isMobileLayout = isMobile && !isDesktopViewport;

  return (
    <Nav className={`${styles.topbarActions} ml-auto d-flex align-items-center`}>
      {userDataFmt?.profile?.formData?.categoriaProfessionale !== 'aso' && (
        <LanguageSelector className={styles.languageAction} data-testid="topbar-language-selector" />
      )}
      {!isLoggedIn && showLoginButtonIfNeeded && (
        <Button variant={'warning'} className={`tootor-button tootor-button--primary ${styles.loginAction} ml-2`} onClick={onLogin}>
          {t('labels.accedi')}
        </Button>
      )}
      {isLoggedIn && (
        <>
           {!subscription && !isNative && showSubscribeButtonIfNeeded && (
            <Button variant={'primary'} as={Link} to={'/plans'} className={'tootor-button tootor-button--secondary mr-2 ml-2'} size={'sm'}>
              {t('labels.abbonati')}
            </Button>
          )}
          {(!!subscription || !isMobileLayout || isNative) && window.location.pathname !== '/notifications' ? (
            <>
              {!isNative && (
                <IconButton
                  icon={faSearch}
                  to={'/search'}
                className={`${styles.tootorAppBarIconButton} ${styles.searchAction} d-lg-none ${!!subscription ? 'ml-2' : ''}`}
                />
              )}
              <Dropdown
                data-testid="topbar-notifications"
                className={styles.notificationDropdown}
                onToggle={(isOpen) => {
                  if (isOpen) return;
                  cleanNotifications();
                }}
              >
                <Dropdown.Toggle as={NotificationButtonToggle}>{notificationBadge}</Dropdown.Toggle>
                <Dropdown.Menu align={'right'} className={`${styles.notificationsMenu} tootor-dropdown-menu`}>
                  <NotificationsList isDropdown={true} />
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : (
            <IconButton
              icon={faSearch}
              to={'/search'}
              className={`${styles.tootorAppBarIconButton} ${styles.searchAction} ${!isNative ? 'd-lg-none' : ''}`}
            />
          )}
          <ProfileCircle />
        </>
      )}
    </Nav>
  );
};

export { TopbarActions };
